import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeImporter  {
    _originalTypeClassName = "zERP.BO.EmployeeImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeImporter.translate = translateService;
}
this.info = null;
this.EmployeeImporterKey = null;
this._key = this.EmployeeImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
info:any;
private _EmployeeImporterKey:any;
get EmployeeImporterKey(): any {
    return this._EmployeeImporterKey;
  }
set EmployeeImporterKey(value: any) {
    this._EmployeeImporterKey = value;
    this._key = value;
  }

static ParseDocumentType(docType: any): any{return (docType == "ΑΣΤΥΝΟΜΙΚΗ" ? Domain.DocumentType.IdCard : Domain.DocumentType.Passport);
}
static ParseEducationLevel(el: any): any{return "";
}
static ParseFamilyStatus(status: any): any{return (status == "ΕΓΓΑΜΟ" ? Domain.FamilyStatus.Married : ((status == "ΔΙΑΖΕΥΓΜΕΝΟ" ? Domain.FamilyStatus.Divorced : ((status == "ΑΓΑΜΟ" ? Domain.FamilyStatus.Single : Domain.FamilyStatus.Widowed)))));
}
static ParseGeder(el: any): any{return (el == "ΑΝΔΡΑΣ" ? Domain.Gender.Male : ((el == "ΓΥΝΑΙΚΑ" ? Domain.Gender.Female : Domain.Gender.Other)));
}
static ParseHasUnemploymentBenefit(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}
static ParseMilitaryObligations(el: any): any{return (el == "ΝΑΙ" ? Domain.MilitaryObligations.Yes : ((el == "ΟΧΙ" ? Domain.MilitaryObligations.No : Domain.MilitaryObligations.NotRequired)));
}
static ParseNewlyInsured(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeImporterKey == null || $this.EmployeeImporterKey == 0;
            }


}